import { render, staticRenderFns } from "./InfoCircle.vue?vue&type=template&id=7d54ad34&scoped=true&"
import script from "./InfoCircle.vue?vue&type=script&lang=js&"
export * from "./InfoCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54ad34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d54ad34')) {
      api.createRecord('7d54ad34', component.options)
    } else {
      api.reload('7d54ad34', component.options)
    }
    module.hot.accept("./InfoCircle.vue?vue&type=template&id=7d54ad34&scoped=true&", function () {
      api.rerender('7d54ad34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/InfoCircle.vue"
export default component.exports